// Coinsurance arrives as a fraction (0.29 = 29%); rounding the scaled value keeps the displayed
// percent a whole number so floating-point products like 0.29 * 100 (28.999999999999996) never reach the
// UI. A non-finite fraction — an absent benefit field despite the number type — yields 0, not NaN%.
export function toCoinsurancePercent(fraction: number): number {
  return Number.isFinite(fraction) ? Math.round(fraction * 100) : 0;
}

export function formatUsd(amount: number): string {
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const hasCents = !Number.isInteger(safeAmount);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2
  }).format(safeAmount);
}
